export const socialsData = {
    github: 'https://github.com/haidermaaz/Maaz-Haider',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/maaz-haider-a71163234/',
    instagram: '',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: 'https://medium.com/@sreerag.rajan5',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}